// React Imports
import * as React from "react";
import {useDispatch, useSelector} from "react-redux";


// Mui Imports
import MenuItem from "@mui/material/MenuItem";
import {
    Avatar, Button, Dialog, DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    ListItemIcon,
    ListItemText,
    Tooltip
} from "@mui/material";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";


// App Imports
import Box from "@mui/material/Box";
import {changeWorkQueue} from "../../workQueueSlice";


// main function
export default function DeleteContract({ onMenuClose, rowContractData }) {

    const [confirmOpen, setConfirmOpen] = React.useState(false);

    // ****************** BEGIN DISPATCH ****************************

    const dispatchData = useDispatch();

    // ****************** END DISPATCH ****************************



    const handleDeleteClick = () => {
        setConfirmOpen(true);
    };


    const handleConfirmClose = () => {
        setConfirmOpen(false);
        onMenuClose();
        dispatchData(changeWorkQueue({actionMenuState: false }));
    };


    const handleConfirmDelete = (rowData) => {
        setConfirmOpen(false);
        onMenuClose();
        console.log("Deleting Contract(s) from action menu");
        dispatchData(changeWorkQueue({
            actionMenuAction: "Delete"
        }))
    };


            return (
            <Box>
                {(
                            (rowContractData.comboStatus !== "Approved"
                                || rowContractData.comboStatus !== "Finalized")
                    ) &&
                    <Box>
                <MenuItem
                onClick={handleDeleteClick}
            >
                <ListItemIcon>
                    <DeleteOutlineIcon fontSize="small"/>
                </ListItemIcon>
                <ListItemText>Delete</ListItemText>
            </MenuItem>

    <Dialog open={confirmOpen} onClose={handleConfirmClose}>
        <DialogTitle>Confirm Delete</DialogTitle>
        <DialogContent>
            <DialogContentText>
                Are you sure you want to delete this contract and any child contracts? This action cannot be undone.
            </DialogContentText>
        </DialogContent>
        <DialogActions>
            <Button onClick={handleConfirmClose} color="primary">
                Cancel
            </Button>
            <Button onClick={handleConfirmDelete} color="error">
                Delete
            </Button>
        </DialogActions>
    </Dialog>
                    </Box>
}
            </Box>

)

}
